/**
 * CreateBinLabelsButton
 */
import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';

// Actions
import { updateQueryString } from '../../../../../../../../services/router/actions';

interface Props {
    updateQueryString: Function;
}

class CreateGroupButton extends React.PureComponent<Props> {
    handleClick = () => {
        this.props.updateQueryString({
            eventPrintModal: true,
            seasonalEventModal: undefined
        });
    };

    render() {
        return (
            <Button primary fluid onClick={this.handleClick}>
                Create Bin Labels
            </Button>
        );
    }
}

export default connect(
    null,
    { updateQueryString }
)(CreateGroupButton);
